import { createApi } from "../axiosInstance";
import { createBankApi } from "../shared/bankApiFactory";

const api = createApi("myBusiness");

export const {
  createBankRegistry,
  createCashRegistry,
  updateBankCash,
  deleteBankCash,
  getBankByModeTransactionType,
  getCashByModeTransactionType,
  getCashById,
  getBankById,
  downloadCashBookStatement,
  downloadBankStatement,
  getIfscDetails,
  getOverallStock,
  downloadOverallStockReport,
  downloadStockRegister,
} = createBankApi(api);
